<template>
  <v-dialog
      v-model="dialog"
      fullscreen=""
      hide-overlay=""
      transition="dialog-bottom-transition"
      persistent="">
    <v-card elevation="0" outlined>
      <v-card-title class="text-h3">
        <v-icon large="" color="#333">mdi-account</v-icon>
        CIDADÃO
        <v-spacer></v-spacer>
        <v-icon @click="close">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <div>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card outlined elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h4">
                  DADOS DO ENCAMINHAMENTO
                </v-card-title>
                
                <v-card-text class="text--primary">
                  <p><span class="font-weight-bold">Situação: </span>{{ (this.testTextHasValue(citizen.descricaoStatusEncaminhamento)) ? citizen.descricaoStatusEncaminhamento : "Não processado" }}</p>

                  <p v-if="showInformationSAS"><span class="font-weight-bold">Tipologia: </span> {{ tipoServico }}<br/>
                     <span class="font-weight-bold">Nome do serviço: </span> {{ nomeServico }} <br>
                     <span class="font-weight-bold">Endereço: </span> {{ endereco }} <span v-if="this.testTextHasValue(complemento)"> - <span class="font-weight-bold">Complemento: </span> {{ complemento }}</span>
                  </p>

                  <p v-if="showInformationSAS"><span class="font-weight-bold">Distrito: </span>{{ descricaoDistrito }} <br>
                      <span class="font-weight-bold">SAS: </span> {{ descricaoSAS }} <br>
                      <span class="text-caption font-italic" v-show="showLocalSigiloso">Entrar em contato com o seu Centro de Referência ou com CPAS para determinar a localização do serviço.</span></p>

                  <p v-if="showInfoCancelamento"><span class="font-weight-bold">Data cancelamento: </span>{{ dataExclusaoEncaminhamento }}<br>
                    <span class="font-weight-bold">Motivo: </span>{{ dcMotivoExclusaoEncaminhamento }}<br>
                    <span class="font-weight-bold">Justificativa: </span>{{ justificativaExclusaoEncaminhamento }}</p>
                  
                  <p v-if="showInfoDecurso"><span class="font-weight-bold">Data decurso de prazo: </span>{{ dataDecursoPrazo }}</p>

                  <p v-if="showInfoConcluido"><span class="font-weight-bold">Data vinculação: </span>{{ dataVinculacao }}</p>
                  <p v-if="showInfoConcluidoPernoite"><span class="font-weight-bold">Data pernoite: </span>{{ dataPernoite }}</p>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="12">

              <v-card outlined elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h4">
                  IDENTIFICAÇÃO
                </v-card-title>
                <v-card-text class="text--primary">
                  <p><span class="font-weight-bold">Nome: </span>{{ citizen.nome }}</p>
                  <p v-if="this.testTextHasValue(citizen.citizenSISA)"><span class="font-weight-bold">Código SISA: </span>{{ citizen.citizenSISA }}</p>
                  <p><span class="font-weight-bold">Nome social: </span>{{ citizen.nomeSocial }}</p>
                  <p><span class="font-weight-bold">Nome da mãe: </span>{{ citizen.nomeMae }}</p>
                  <p><span class="font-weight-bold">Data de nascimento: </span>{{ citizen.dataNascimento | formatDate_BR() }}</p>
                  <p><span class="font-weight-bold">É Gestante?</span>&nbsp;&nbsp;<span :class="(citizen.indicadorGestante == 1)? 'green--text' : 'red--text'">{{ (citizen.indicadorGestante)? 'SIM' : 'NÃO' }}</span></p>
                  <p v-if="this.testTextHasValue(citizen.descricaoGrauDependencia)"><span class="font-weight-bold">Grau de Dependência: </span>{{ citizen.descricaoGrauDependencia }}</p>
                  <p><span class="font-weight-bold">Gênero: </span>{{ citizen.descricaoTipoSexo }}</p>
                  <p><span class="font-weight-bold">Identidade de gênero: </span>{{ citizen.descricaoIdentidadeSexual }}</p>
                  <p><span class="font-weight-bold">Raça/Cor: </span>{{ citizen.descricaoRaca }}</p>
                  <p><span class="font-weight-bold">Nacionalidade: </span>{{ citizen.descricaoTipoNacionalidade }} 
                    - <span class="font-weight-bold">País: </span>{{ citizen.documentoIdentidadeEstrangeiro.nomePaisOrigem }}
                    <span v-if="this.testTextHasValue(citizen.documentoIdentidadeEstrangeiro.numeroRNE)"> - <span class="font-weight-bold">RNE: </span>{{ citizen.documentoIdentidadeEstrangeiro.numeroRNE }}</span> 
                    <span v-if="this.testTextHasValue(citizen.documentoIdentidadeEstrangeiro.numeroPassaporte)"> - <span class="font-weight-bold">Passaporte: </span>{{ citizen.documentoIdentidadeEstrangeiro.numeroPassaporte }}</span> 
                  </p>
                  <p v-if="this.testTextHasValue(citizen.numeroCPF)"><span class="font-weight-bold">CPF: </span>{{ this.formatCPFNumber(citizen.numeroCPF) }}</p>
                  <p v-if="this.testTextHasValue(citizen.documentoIdentidade.numero)"><span class="font-weight-bold">RG: </span>{{ citizen.documentoIdentidade.numero }}
                    <span v-if="this.testTextHasValue(citizen.documentoIdentidade.digito)">-{{ citizen.documentoIdentidade.digito }}</span>
                    <span v-if="this.testTextHasValue(citizen.documentoIdentidade.orgaoEmissor)"> - <span class="font-weight-bold">Orgão emissor: </span>{{ citizen.documentoIdentidade.orgaoEmissor }}</span>
                      <span v-if="this.testTextHasValue(citizen.documentoIdentidade.uf)"> / {{ citizen.documentoIdentidade.uf }}</span>
                      <span v-if="this.testTextHasValue(citizen.documentoIdentidade.dataEmissao)"> - <span class="font-weight-bold">Data de emissão: </span>{{ citizen.documentoIdentidade.dataEmissao | formatDate_BR() }}</span>
                  </p>
                  <div v-if="citizen.tipoCertidao == 'A'">
                      <div v-if="this.testTextHasValue(citizen.certidaoNascimento.numero)">
                        <p>
                            <span class="font-weight-bold">Certidão de Nascimento: </span>{{ citizen.certidaoNascimento.numero }}
                            <span v-if="this.testTextHasValue(citizen.certidaoNascimento.livro)"> - <span class="font-weight-bold">Livro: </span>{{ citizen.certidaoNascimento.livro }}</span>
                            <span v-if="this.testTextHasValue(citizen.certidaoNascimento.folha)"> - <span class="font-weight-bold">Folha(as): </span>{{ citizen.certidaoNascimento.folha }}</span>
                            <span v-if="this.testTextHasValue(citizen.certidaoNascimento.nomeCidade)"> - <span class="font-weight-bold">Cidade: </span>{{ citizen.certidaoNascimento.nomeCidade }} / {{ citizen.certidaoNascimento.uf }}</span>
                        </p>
                      </div>
                  </div>
                  <div v-else>
                      <div v-if="this.testTextHasValue(citizen.certidaoNascimento.numeroNovo)">
                        <p><span class="font-weight-bold">Certidão de Nascimento: </span>{{ citizen.certidaoNascimento.numeroNovo }}</p>
                      </div>
                  </div>
              </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                  ACESSIBILIDADE E AUTONOMIA
                </v-card-title>
                <v-card-text class="text--primary">
                  <p><span class="font-weight-bold">Necessita vaga acessível?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorVagaAcessivel)? 'green--text' : 'red--text'">{{ this.isTrueValue(citizen.indicadorVagaAcessivel)? 'SIM' : 'NÃO' }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorVagaAcessivel) && this.testTextHasValue(citizen.descricaoVagaAcessivel)"><br/><span class="font-weight-bold">Justificativa:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoVagaAcessivel }}</span></span>
                  </p>
                  <p><span class="font-weight-bold">Necessita de Cuidados de Terceiros?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorCuidadoTerceiros)? 'green--text' : 'red--text'">{{ this.isTrueValue(citizen.indicadorCuidadoTerceiros)? 'SIM' : 'NÃO' }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorCuidadoTerceiros) && !this.isArrayNullEmpty(citizen.formasCuidado)"><br/><span class="font-weight-bold">Cuidado(s) necessário(s):</span>&nbsp;&nbsp;<span>{{ citizen.formasCuidado.map(f => f.descricao).join(', ') }}</span></span>
                  </p>
                  <p><span class="font-weight-bold">Possui Deficiências?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPossuiDeficiencia)? 'green--text' : 'red--text'">{{ this.isTrueValue(citizen.indicadorPossuiDeficiencia)? 'SIM' : 'NÃO' }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorPossuiDeficiencia) && !this.isArrayNullEmpty(citizen.deficiencias)"><br/><span class="font-weight-bold">Deficiência(s):</span>&nbsp;&nbsp;<span>{{ this.getTextoDeficiencia(citizen.deficiencias) }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                  ACOLHIMENTO
                </v-card-title>
                <v-card-text class="text--primary">
                  <p><span class="font-weight-bold">Já esteve Acolhido?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorAcolhimentoAnterior)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorAcolhimentoAnterior) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorAcolhimentoAnterior) && this.testTextHasValue(citizen.descricaoLocalAcolhimentoAnterior)"><br/><span class="font-weight-bold">Serviços:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoLocalAcolhimentoAnterior }}</span></span>
                  </p>
                  <p><span class="font-weight-bold">Possui familiar(es) acolhido(s)?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPossuiFamiliarAcolhido)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorPossuiFamiliarAcolhido) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorPossuiFamiliarAcolhido) && this.testTextHasValue(citizen.descricaoFamiliarAcolhido)"><br/><span class="font-weight-bold">Serviços:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoFamiliarAcolhido }}</span></span>
                  </p>
                  <p><span class="font-weight-bold">Vítima de violência?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorVitimaViolencia)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorVitimaViolencia) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorVitimaViolencia) && citizen.distritos != null && citizen.distritos.length > 0"><br/><span class="font-weight-bold">Distritos:</span>&nbsp;&nbsp;<span>{{ this.convertDistrictArrayToString(citizen.distritos, 'V') }}</span></span>
                  </p>
                  <p><span class="font-weight-bold">Está sob ameaça de morte?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorAmeaca)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorAmeaca) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorAmeaca) && citizen.distritos != null && citizen.distritos.length > 0"><br/><span class="font-weight-bold">Distritos:</span>&nbsp;&nbsp;<span>{{ this.convertDistrictArrayToString(citizen.distritos, 'A') }}</span></span>
                  </p>
                  <p><span class="font-weight-bold">PPCAAM foi acionado?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPPCAAM)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorPPCAAM) }}</span>
                  </p>
                  <p v-if="this.isTrueValue(citizen.indicadorVitimaViolencia) || this.isTrueValue(citizen.indicadorAmeaca)"><span class="font-weight-bold">Acolhimento sigilogo?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorAcolhimentoSigiloso)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorAcolhimentoSigiloso) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorAcolhimentoSigiloso) && !this.isArrayNullEmpty(citizen.tiposServicosSolicitados)"><br/><span class="font-weight-bold">Tipologia:</span>&nbsp;&nbsp;<span>{{ citizen.tiposServicosSolicitados.map(t => t.descricao).join(', ') }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                    PROCESSOS
                </v-card-title>
                <v-card-text class="text--primary">
                  <p><span class="font-weight-bold">Possui Ordem Judicial?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorOrdemJudicial)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorOrdemJudicial) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorOrdemJudicial) && this.testTextHasValue(citizen.descricaoOrdemJudicial)"><br/><span class="font-weight-bold">Determinação Judicial:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoOrdemJudicial }}</span></span>
                  </p>
                  <p v-if="(currentAge > 0 && currentAge < 18)"><span class="font-weight-bold">Há processos na Vara da Infância e Juventude?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorProcessoVIJ)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorProcessoVIJ) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorProcessoVIJ) && this.testTextHasValue(citizen.nomeVaraInfanciaJuventude)"><br/><span class="font-weight-bold">Local:</span>&nbsp;&nbsp;<span>{{ citizen.nomeVaraInfanciaJuventude }}</span></span><span v-if="this.isTrueValue(citizen.indicadorProcessoVIJ) && this.testTextHasValue(citizen.descricaoProcessoVIJ)"> - Processo:&nbsp;&nbsp;<span>{{ citizen.descricaoProcessoVIJ }}</span></span>
                  </p>
                  <p v-if="(currentAge >= 14 && currentAge <= 21)"><span class="font-weight-bold">Há processos no DEIJ?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorProcessoDEIJ)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorProcessoDEIJ) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorProcessoDEIJ) && this.testTextHasValue(citizen.descricaoProcessoDEIJ)"><br/><span class="font-weight-bold">Processo:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoProcessoDEIJ }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                    SAÚDE
                </v-card-title>
                <v-card-text class="text--primary">
                  <p><span class="font-weight-bold">Utiliza medicação de uso contínuo?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorMedicacaoContinua)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorMedicacaoContinua) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorMedicacaoContinua) && this.testTextHasValue(citizen.descricaoMedicacaoContinua)"><br/><span class="font-weight-bold">Medicamentos:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoMedicacaoContinua }}</span></span>
                  </p>
                  <p><span class="font-weight-bold">Realiza acompanhamento em serviço de saúde?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorFazAcompanhamentoServicoSaude)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorFazAcompanhamentoServicoSaude) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorFazAcompanhamentoServicoSaude) && this.testTextHasValue(citizen.descricaoAcompanhamentoServicoSaude)"><br/><span class="font-weight-bold">Local:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoAcompanhamentoServicoSaude }}</span></span>
                  </p>
                  <p><span class="font-weight-bold">Realiza acompanhamento no CAPS?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorAcompanhamentoCAPS)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorAcompanhamentoCAPS) }}</span>
                    <span v-if="this.isTrueValue(citizen.indicadorAcompanhamentoCAPS) && this.testTextHasValue(citizen.descricaoAcompanhamentoCAPS)"><br/><span class="font-weight-bold">Local:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoAcompanhamentoCAPS }}</span></span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col  cols="12" sm="12" md="12">
              <v-card outlined elevation="0" class="pa-md-4 mx-lg-auto">
                <v-card-title class="text-h5 font-weight-bold">
                    INFORMAÇÕES ADICIONAIS
                </v-card-title>
                <v-card-text class="text--primary">
                  <p><span class="font-weight-bold">Possui autonomia financeira?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.possuiAutonomiaFinanceira)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.possuiAutonomiaFinanceira) }}</span></p>
                  <p><span class="font-weight-bold">Possui carroça?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPossuiCarroca)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorPossuiCarroca) }}</span></p>
                  <p><span class="font-weight-bold">Possui animal de estimação?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorPossuiAnimalEstimacao)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorPossuiAnimalEstimacao) }}</span></p>
                  <p><span class="font-weight-bold">Está em período de convalescência?</span>&nbsp;&nbsp;&nbsp;<span :class="this.isTrueValue(citizen.indicadorConvalescencia)? 'green--text' : 'red--text'">{{ this.testNullField(citizen.indicadorConvalescencia) }}</span>
                     <span v-if="this.isTrueValue(citizen.indicadorConvalescencia) && this.testTextHasValue(citizen.descricaoPrognostico)"><br/><span class="font-weight-bold">Prognóstico:</span>&nbsp;&nbsp;<span>{{ citizen.descricaoPrognostico }}</span></span></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer/>
        <v-btn
            text
            large
            elevation="0"
            class="grey darken-2"
            @click="close">
            <v-icon left>mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
    <snackbar
        :text="snackbarMessage"
        :color="snackbarColor"
    />    
  </v-dialog> 
</template>
<script>
  import moment from 'moment';
  import citizenService from '../../services/citizen.service';
  import snackbarMixin from "@/mixins/snackbar.mixin";

  export default {
    mixins: [snackbarMixin],
    props:{
      dialog:{
        default:false
      }
    },
    data(){
      return {
        currentAge: -1,
        descricaoSAS:'',
        descricaoDistrito:'',
        nomeServico:'',
        tipoServico:'',
        justificativaExclusaoEncaminhamento:'',
        dcMotivoExclusaoEncaminhamento:'',
        dataExclusaoEncaminhamento:'',
        dataDecursoPrazo:'',
        dataVinculacao:'',
        dataPernoite:'',
        showInformationSAS: false,
        showInfoDecurso: false,
        showInfoCancelamento: false,
        showInfoConcluido:false,
        showInfoConcluidoPernoite:false,
        showLocalSigiloso:false,
        endereco:'',
        complemento:'',
        inTipoReserva:'',
        citizen: {
          "codigoCidadaoSolicitacao": '',
          "indicadorCidadãoPrincipal": '',
          "parentescoCidadaoPrincipal": '',
          "codigoCidadaoSISA": '',
          "possuiAutonomiaFinanceira": '',
          "nome": '',
          "nomeSocial": '',
          "nomeMae": '',
          "dataNascimento": '',
          "codigoTipoSexo": '',
          "codigoIdentidadeSexual": '',
          "codigoRaca": '',
          "codigoEstadoCivil": '',
          "documentoIdentidade": {
            "numero": '',
            "digito": '',
            "orgaoEmissor": '',
            "uf": '',
            "dataEmissao": '',
          },
          "numeroCPF": '',
          "certidaoNascimento": {
            "numero": '',
            "livro": '',
            "folha": '',
            "codigoCidade": '',
            "nomeDistrito": '',
            "dataEmissao": '',
            "nomeCidade": '',
            "uf": ''
          },
          "documentoIdentidadeEstrangeiro": {
            "numeroRNE": '',
            "dataEntradaPais": '',
            "dataNaturalizacao": '',
            "codigoPaisOrigem": '',
            "numeroPortariaNaturalizacao": '',
            "numeroPassaporte": '',
            "nomePaisOrigem": '',
          },
          "descricaoPrognostico": '',
          "indicadorTecnologiaAssistiva": '',
          "indicadorCuidadoTerceiros": '',
          "indicadorGestante": '',
          "indicadorPossuiFamiliarAcolhido": '',
          "descricaoFamiliarAcolhido": '',
          "indicadorAcolhimentoSigiloso": '',
          "indicadorVitimaViolencia": '',
          "indicadorAcolhimentoAnterior": '',
          "descricaoLocalAcolhimentoAnterior": '',
          "indicadorAmeaca": '',
          "descricaoLocalEncontraAmeacado": '',
          "indicadorProcessoVIJ": '',
          "descricaoProcessoVIJ": '',
          "indicadorMedicacaoContinua": '',
          "descricaoMedicacaoContinua": '',
          "indicadorAcompanhamentoCAPS": '',
          "indicadorPossuiCarroca": '',
          "descricaoAcompanhamentoServicoSaude": '',
          "indicadorPossuiAnimalEstimacao": '',
          "enderecoCidadao": {
          "codigoSubprefeitura": '',
          "codigoTipoLogradouro": '',
          "pontoReferencia": '',
          "numeroLogradouro": '',
          "complemento": '',
          "nomeBairro": '',
          "cep": '',
          "codigoDistrito": '',
          "codigoCidade": '',
          "siglaUF": '',
          "siglaLogradouro": '',
          "nomeCidade": '',
          "DescricaoSubprefeitura": '',
          "DescricaoDistrito": '',
          },
          "deficiencias": [{
              "codigo": '',
              "afetaMobilidade": '',
            }
          ],
          "formasCuidado": [{
            "codigo": '',
            "descricao": '',
            }
          ],
          "tiposServicosSolicitados": [{
            "codigo": '',
            "descricao": '',
            }
          ],
          "indicadorMobilidadeAfetada": '',
          "descricaoTipoSexo": '',
          "DescricaoIdentidadeSexual": '',
          "descricaoRaca": '',
          "descricaoEstadoCivil": '',
          "descricaoTipoNacionalidade": '',
        },
      }
  },
  methods:{
    loadRequestCitizen(item,idSolicitacao){
      this.citizen = item == null ? '' : item;
      this.getPresentAge(this.citizen.dataNascimento);
      if(item.codigoSrvicoHospedagemReservaVaga != null && item.codigoSrvicoHospedagemReservaVaga != undefined)
        this.getInformacaoEncaminhamento(item.codigoSrvicoHospedagemReservaVaga,idSolicitacao);
      this.setInformations();
      this.showInformations(this.citizen.descricaoStatusEncaminhamento);
    },
    showInformations(value){
      if(this.testTextHasValue(value))
      {
        
        this.showInformationSAS = true;
        let indicaPernoite = this.testTextHasValue(this.inTipoReserva);
        
        if(value =="Cancelado"){
          this.showInfoCancelamento = true;
        } 
        else if(value=="Concluído"){
          if(indicaPernoite=="1"){
            this.showInfoConcluidoPernoite = true;
          } else{
            this.showInfoConcluido = true;
          }
        }
        else if(value=="Não Concluído"){
          this.showInfoDecurso = true;
        }
      }
    },
    setInformations() {
      this.showInformationSAS = false;
      this.showInfoCancelamento = false;
      this.showInfoConcluido = false;
      this.showInfoDecurso = false;
      this.showInfoConcluidoPernoite = false;
    },
    close(){
      this.$emit('update:dialog', false)
    },
    testNullField(value){
      if(this.isTrueValue(value))
      return 'Sim';
      else if(value == false || value == "0" || value === 0)
      return 'Não';
      else
      return "Não informado";
    },
    testTextHasValue(value){
      return (value != null && value.toString().length > 0);
    },
    testTinyntField(value){
      if(value == 1)
      return 'Sim';
      else if(value == 0)
      return 'Não';
      else
      return 'Não Informado';
    },
    convertServiceTypeArrayToString(arrServiceType){
      if(arrServiceType == null)
      return '';

      var servicos = arrServiceType.map(function(item){ return item['descricao']});
      return servicos.join(', ');
    },
    convertDisabilityArrayToString(arrDisabilites){
      if(arrDisabilites == null)
      return '';

      var deficiencias = arrDisabilites.map(function(item){ return item['descricao']});
      return deficiencias.join(', ');
    },
    convertDistrictArrayToString(arrDistrict, type){
      if(arrDistrict == null)
        return '';
      
      let listFiltered = arrDistrict.filter(d => d.tipoUso == type);
      if(listFiltered == null)
        return '';
      
      var distritos = listFiltered.map(item => item['descricao']).join(', ');

      return distritos;
    },
    clear(){
      //this.citizen = '';
    },
    isTrueValue(value){
        let isTrue = ((value != undefined) && (value == "true" || value == "1" || value == true || value === 1));
        return isTrue;
    }, 
    isArrayNullEmpty(arr){
      let isNull = (arr == null || arr == '' || arr == [] || arr.length == 0);
      return isNull;
    },
    checkNullTF(value){
      if(value == undefined || value == null || value == '')
        return "Não informado";
      else if(this.isTrueValue(value))
        return "Sim";
      else
        return "Não";
    },
    getPresentAge(value){
      let presentDay = moment();
      let birthDate = moment(value);
      let valid = birthDate.isValid();
      if(valid){
        this.currentAge = presentDay.diff(birthDate, 'years');
      }
      else {
        this.currentAge = -1;
      }
    },
    formatCPFNumber(value){
      let cpf = value.toString().replace(/[^\d]/g,'');
      cpf = '00000000000' + cpf;
      cpf = cpf.substring(cpf.length - 11, cpf.length);
      cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

      return cpf;
    },
    getInformacaoEncaminhamento(idEncaminhamento, idSolicitacao){
      citizenService.getEncaminhamentoCidadao(idEncaminhamento, parseInt(idSolicitacao))
                .then(result => {
                    if(result.status == 200 && result.data){
                        let r = result.data;

                        if(r) {
                            this.nomeServico = r.nm_servico;
                            this.tipoServico = r.dc_tipo_servico;
                            this.justificativaExclusaoEncaminhamento = r.tx_justificativa_exclusao_encaminhamento;
                            this.dcMotivoExclusaoEncaminhamento = r.dc_motivo_exclusao_encaminhamento;
                            this.descricaoDistrito = r.nomeDistrito;
                            this.descricaoSAS = r.nomeSubprefeitura;
                            this.dataVinculacao = r.dtVinculacao;
                            this.dataDecursoPrazo = r.dtDecursoPrazo;
                            this.dataExclusaoEncaminhamento = r.dtCancelamento;
                            this.endereco = r.dc_endereco;
                            this.complemento = r.dc_complemento_endereco;
                            this.dataPernoite = r.dtPernoite;
                            this.inTipoReserva = r.in_tipo_reserva;

                            this.showObsSigiloso(this.descricaoSAS);
                        }
                    }
                }).catch(error => {
                    this.showSnackbar("Não foi possível efetuar a operação.", 'error');
                    console.log(error);
                });
    },
    getTextoDeficiencia(def){
      let textoDeficiencia = [];
      let texto = '';
      if(def != null && def != undefined && def.length > 0){
        for(let i = 0; i < def.length; i++){
          texto = def[i].descricao + ' - Afeta Mobilidade: ' + (this.isTrueValue(def[i].afetaMobilidade) ? "SIM" : "NÃO");
          console.log(texto);
          textoDeficiencia.push(texto);
        }
      }

      return textoDeficiencia.join(', ');
    },
    showObsSigiloso(value){
      console.log(value);
      if(value == "SIGILOSO"){
        this.showLocalSigiloso = true;
      }else{
        this.showLocalSigiloso = false;
      }
    }
  },
  mounted(){
  },
  }
</script>